import React, { FC, useCallback, useEffect, useState } from "react";

import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { useToast } from "@/components/ui/use-toast";
import * as m from "@/paraglide/messages";
import { useAppSelector } from "@/services/hooks/redux.hooks";

import { Percentages } from "./types";

export const PercentageBar: FC<{
  total?: number;
  onValueChange?: React.Dispatch<{ result: number; percentage: number }>;
  reset?: boolean;
}> = ({ total, onValueChange, reset }) => {
  const { tradeAction, tps } = useAppSelector((state) => state.trade);
  const { toast } = useToast();

  const [value, setValue] = useState<string>("");

  const onChange = useCallback(
    (response: string) => {
      if (total === 123456789) {
        toast({
          title: m.attention(),
          description: m.legal_swift_chipmunk_commend(),
          variant: "destructive",
          duration: 5000,
        });
        return;
      }
      if (total) {
        const selected = parseInt(response);
        const result = (total * selected) / 100;

        if (onValueChange) {
          onValueChange({ percentage: selected, result });
        }
      }

      setValue(response);
    },
    [onValueChange, toast, total],
  );

  useEffect(() => {
    setValue("");
  }, [tradeAction, tps.length]);

  useEffect(() => {
    if (reset) {
      setValue("");
    }
  }, [reset]);

  return (
    <ToggleGroup
      type="single"
      className="w-full border-2 rounded-sm gap-0 overflow-hidden"
      onValueChange={onChange}
      value={value}
    >
      {Object.keys(Percentages).map((item, index, arr) => {
        const isLastItem = index === arr.length - 1;
        return (
          <React.Fragment key={index}>
            <ToggleGroupItem
              value={item}
              key={item}
              className="w-full disabled:opacity-100 rounded-sm data-[state=on]:bg-gray-200 dark:data-[state=on]:bg-slate-800"
            >
              {item}
            </ToggleGroupItem>
            {!isLastItem && <div className="w-3 h-full bg-secondary" />}
          </React.Fragment>
        );
      })}
    </ToggleGroup>
  );
};
